import en from './en.json';
import de from './de.json';
import da from './da.json';
import ar from './ar.json';
import zh from './zh.json';
import codes from './codes.json';
export default { en, de, da, ar, zh, codes };
